module.exports = __webpack_public_path__ + "static/media/chantal_french_candian.8185b43b.mp3";